import React from 'react';
import upChevron from 'assets/chevron-up.svg';
import useHoldRepeat from 'hooks/useRepeatHook';

const ChevronUpIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => {
  const { start, stop } = useHoldRepeat(onClick);

  return (
    <img
      style={{ cursor: 'pointer', userSelect: 'none' }}
      draggable={false}
      src={upChevron}
      alt="up-chevron-icon"
      className={className}
      onMouseDown={() => {
        start();
      }}
      onMouseUp={() => {
        stop();
      }}
    />
  );
};

export default ChevronUpIcon;
